import styled from 'styled-components';
import { LinkButton } from 'src/components/Button/LinkButton';

export const StyledContractDetails = styled.div`
  font-size: 16px; // TODO: isn't this already 16px here?

  .headline {
    color: var(--black);
    text-align: center;
    font-weight: 500;
    font-size: 0.875em;
    margin: 0;

    @media (min-width: 551px) {
      font-size: 1.0625em;
    }
  }

  .bullets {
    column-count: 2;
    list-style: none;
    margin: 1em 0 0 0;
    padding: 0;
  }

  .bullet {
    display: flex;
    min-height: 1.5em;
    margin: 0 0 0.75em 0;

    &:nth-child(2) {
      // Forces the list to break after the second bullet, ensuring 3rd bullet is in the second column
      break-after: column;
      // Firefox does not recognize break-after, prevent 2nd bullet from getting broken when it fails.
      break-inside: avoid;
    }

    &:nth-child(even) {
      // Removes bottom margin from second bullet and the change tab button
      margin: 0;
    }

    .checkmark {
      min-width: 0.75em;
      display: inline-block;
      margin: 0.1875em 0.4375em 0 0;
      color: ${props => props.theme.merchantColor};
      fill: ${props => props.theme.merchantColor};
    }
  
    .text {
      display: inline-block;
      font-weight: 400;
      font-size: 0.8125em;
      line-height: 0.9375em;
  
      @media (min-width: 551px) {
        font-size: 1em;
        line-height: 1.125em;
      }
    }

    &.change-tab {
      display: flex;
      align-items: center;
    }
  }
`;

export const FaqButton = styled(LinkButton)`
  color: black;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  padding: 0;
  cursor: pointer;

  .icon {
    margin: 0 6px 0 -0.125em;
    display: inline-block;
    vertical-align: middle;
  }

  .text {
    line-height: 0.75em !important; // This is needed to override the @media specificity above
    border-bottom: 1px solid #000;
  }

  &:hover .text {
    border-bottom-color: ${props => props.theme.merchantColor};
  }
`;
